import type { IconProps } from '../types/IconProps.ts';
export const ShoppingBagCheck: IconProps = {
    name: 'ShoppingBagCheck',
    children: [
        `<path d="M13 22H4a1 1 0 0 1-1-1V6l2.7-3.6a1 1 0 0 1 .8-.4h11a1 1 0 0 1 .8.4L21 6v7m0-7H3" />`,
        `<path d="M16 10a4 4 0 0 1-8 0M16 19.12l1.98 1.98q.14.12.28 0L22 17" />`,
    ]
};